import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const each = (source, action) => {
    async function* iterator() {
        for await (const value of source) {
            action(value);
            yield value;
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
